module.exports = __webpack_public_path__ + "img/PLUS_GRILLE_POINTAGE.be9d5b0d.svg";